import { render, staticRenderFns } from "./ApmsBasicImageLibraryInfo.vue?vue&type=template&id=4007b7ec&scoped=true&"
import script from "./ApmsBasicImageLibraryInfo.vue?vue&type=script&lang=js&"
export * from "./ApmsBasicImageLibraryInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4007b7ec",
  null
  
)

export default component.exports